import { OneByOneProduct } from './OneByOneProduct';

export {
  OneByOneProduct,
};
